import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useMemo } from "react";
import { useOutletContext } from "react-router";
import Loader from "components/Common/loader";
import { useTasks } from "feature-module/academic/class-task/hooks/useTasks";
import CalendarFilter from "feature-module/academic/class-task/components/CalendarFilter";
import TaskListCard from "feature-module/academic/class-task/components/TaskListCard";
import TaskDetailsModal from "feature-module/academic/class-task/components/TaskDetailsModal";
import CustomAlert from "components/Common/ui/CustomAlert";

type Ctx = { student: any | null };

const StudentTaskTab: React.FC = () => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedTask, setSelectedTask] = useState<any | null>(null);
  const { student } = useOutletContext<Ctx>();
  const studentId = useMemo(() => student?.id, [student]);
  const classId = useMemo(() => student?.class?.id, [student]);

  const { tasks, loading, error, setFilters } = useTasks({ studentId });

  const handleDateSelect = (date: any) => {
    const formattedDate = date ? date.format("YYYY-MM-DD") : null;
    setSelectedDate(formattedDate);
  };

  const handleTaskClick = (task: any) => {
    console.log(task);
    setSelectedTask(task);
    setModalVisible(true);
  };

  // Refresh tasks when studentId changes
  useEffect(() => {
    if (studentId) {
      setFilters({ studentId });
    }
  }, [studentId, setFilters]);

  if (loading) return <Loader />


  return (
    <div className="p-2">
      {!classId ? (
        <CustomAlert
          message={t("alert.no_class_assigned.message")}
          description={t("alert.no_class_assigned.description")}
          type="warning"
          showIcon
        />
      ) : (
        <>
          <div className="mb-3 d-flex justify-content-end">
            <CalendarFilter
              onDateSelect={handleDateSelect}
              tasks={tasks.filter((task: any) => !!task.date).map((task: any) => ({ date: String(task.date) }))}
            />
          </div>

          <div >
            <TaskListCard
              selectedDate={selectedDate}
              tasks={selectedDate ? tasks.filter((task: any) => task.date === selectedDate) : tasks}
              loading={loading}
              error={error}
              onTaskClick={handleTaskClick}
            />
          </div>

          <TaskDetailsModal
            isOpen={modalVisible}
            onClose={() => setModalVisible(false)}
            selectedTask={selectedTask}
            loading={loading}
          />
        </>
      )}
    </div>
  );
};

export default StudentTaskTab;
